import { useState } from "react";
import PhotoThumbGrid from "./PhotoThumbGrid";

// Generalizes CustodialView's FirstAreaCapture and PhotoCheckin, which
// duplicated this exact before/after multi-photo flow twice (once for the
// post-clock-in guided flow, once for the QR-scan entry point). Here it's
// one component: it knows nothing about Firestore paths, clients, or
// assets — callers pass onCaptureBefore/onCaptureAfter callbacks that
// upload a file and resolve to a URL, and this component only manages the
// step state and thumbnail UI. Works for a janitorial "room" and an HVAC
// "rooftop unit" identically.
export default function BeforeAfterCapture({
  title, subtitle,
  onCaptureBefore, onCaptureAfter, onFinish, onSkip,
  labels = {},
}) {
  const L = { before: "Take BEFORE photo(s)", after: "Take AFTER photo(s)", ...labels };
  const [step, setStep] = useState("before");
  const [beforeUrls, setBeforeUrls] = useState([]);
  const [afterUrls, setAfterUrls] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  const capture = (type) => {
    const input = document.createElement("input");
    input.type = "file"; input.accept = "image/*"; input.capture = "environment";
    input.onchange = async (e) => {
      const file = e.target.files[0]; if (!file) return;
      setUploading(true); setErr("");
      try {
        const url = type === "before" ? await onCaptureBefore(file) : await onCaptureAfter(file);
        if (type === "before") setBeforeUrls(prev => [...prev, url]);
        else setAfterUrls(prev => [...prev, url]);
      } catch (e) {
        setErr("Upload failed — check connection and try again");
      }
      setUploading(false);
    };
    input.click();
  };

  return (
    <div style={{ background:"#fff", borderRadius:"16px", border:"1px solid #E2E8F0", padding:"28px 24px", maxWidth:"400px", margin:"20px auto", textAlign:"center" }}>
      {step === "before" ? (<>
        <div style={{ fontSize:"20px", fontWeight:"700", marginBottom:"4px" }}>{title}</div>
        {subtitle && <div style={{ fontSize:"13px", color:"#64748B", marginBottom:"24px" }}>{subtitle}</div>}
        {err && <div style={{ color:"#DC2626", fontSize:"13px", marginBottom:"10px" }}>{err}</div>}
        <PhotoThumbGrid urls={beforeUrls} />
        <button onClick={()=>capture("before")} disabled={uploading}
          style={{ width:"100%", padding:"22px 0", background: uploading ? "#94A3B8" : "#006B4F", color:"#fff", border:"none", borderRadius:"12px", fontSize:"17px", fontWeight:"700", cursor:"pointer" }}>
          {uploading ? "Uploading…" : beforeUrls.length ? "+ Add another photo" : L.before}
        </button>
        {beforeUrls.length > 0 && (
          <button onClick={()=>setStep("after")} style={{ marginTop:"10px", width:"100%", padding:"12px 0", background:"#16A34A", color:"#fff", border:"none", borderRadius:"10px", fontWeight:"700", cursor:"pointer" }}>Continue to After →</button>
        )}
      </>) : (<>
        <PhotoThumbGrid urls={beforeUrls} />
        <div style={{ fontSize:"20px", fontWeight:"700", marginBottom:"4px" }}>{L.after}</div>
        {err && <div style={{ color:"#DC2626", fontSize:"13px", marginBottom:"10px" }}>{err}</div>}
        <PhotoThumbGrid urls={afterUrls} />
        <button onClick={()=>capture("after")} disabled={uploading}
          style={{ width:"100%", padding:"22px 0", background: uploading ? "#94A3B8" : "#16A34A", color:"#fff", border:"none", borderRadius:"12px", fontSize:"17px", fontWeight:"700", cursor:"pointer" }}>
          {uploading ? "Uploading…" : afterUrls.length ? "+ Add another photo" : L.after}
        </button>
        {afterUrls.length > 0 && (
          <button onClick={()=>onFinish({ beforeUrls, afterUrls })} style={{ marginTop:"10px", width:"100%", padding:"12px 0", background:"#16A34A", color:"#fff", border:"none", borderRadius:"10px", fontWeight:"700", cursor:"pointer" }}>Save &amp; Finish</button>
        )}
      </>)}
      {onSkip && <button onClick={onSkip} style={{ marginTop:"14px", background:"transparent", border:"1px solid #E2E8F0", borderRadius:"10px", padding:"10px", width:"100%", cursor:"pointer" }}>Skip for now</button>}
    </div>
  );
}
